<!-- Global Language Switcher - Fixed Position -->
<div class="global-language-switcher" [ngClass]="themeClasses">
    <!-- Settings Icon Trigger -->
    <div class="settings-trigger" (click)="toggleDrawer()" [class.active]="isOpen" [class.loading]="isLoading"
        [attr.aria-expanded]="isOpen" [attr.aria-label]="'Language Settings - Current: ' + currentLanguageInfo.name"
        role="button" tabindex="0">

        <!-- Settings Icon with Pulse Animation -->
        <div class="icon-container">
            <ion-icon name="settings-outline" class="settings-icon" [class.spinning]="isLoading"></ion-icon>
            <div class="pulse-ring" [class.animate]="!isOpen"></div>
        </div>

        <!-- Current Language Flag (Small) -->
        <div class="current-flag">
            <img [src]="currentLanguageInfo.flag" [alt]="currentLanguageInfo.code" class="flag-mini" />
        </div>
    </div>

    <!-- Creative Drawer/Panel -->
    <div class="language-drawer" [class.open]="isOpen" [class.loading]="isLoading" role="menu"
        [attr.aria-hidden]="!isOpen">

        <!-- Drawer Header -->
        <div class="drawer-header">
            <div class="header-content">
                <ion-icon name="language-outline" class="header-icon"></ion-icon>
                <span class="header-title">{{ 'LANGUAGE' | translate }}</span>
            </div>
            <ion-button fill="clear" size="small" (click)="toggleDrawer()" class="close-btn"
                aria-label="Close language switcher">
                <ion-icon name="close" slot="icon-only"></ion-icon>
            </ion-button>
        </div>

        <!-- Language Options -->
        <div class="language-options">
            <div *ngFor="let lang of supportedLanguages; trackBy: trackByLanguage" class="language-option"
                [class.active]="currentLanguage === lang.code"
                [class.loading]="isLoading && loadingLanguage === lang.code" (click)="selectLanguage(lang.code)"
                role="menuitem" [attr.aria-current]="currentLanguage === lang.code ? 'true' : 'false'"
                [attr.aria-label]="'Select ' + lang.name + ' language'">

                <!-- Flag -->
                <div class="flag-container">
                    <img [src]="lang.flag" [alt]="lang.code" class="flag-image" />
                </div>

                <!-- Language Info -->
                <div class="language-info">
                    <span class="language-name">{{ lang.name }}</span>
                    <span class="language-code">{{ lang.code.toUpperCase() }}</span>
                </div>

                <!-- Status Indicators -->
                <div class="status-indicators">
                    <!-- Loading Spinner -->
                    <ion-spinner *ngIf="isLoading && loadingLanguage === lang.code" name="crescent"
                        class="loading-spinner"></ion-spinner>

                    <!-- Active Check -->
                    <ion-icon *ngIf="!isLoading && currentLanguage === lang.code" name="checkmark-circle"
                        class="active-icon"></ion-icon>

                    <!-- Hover Arrow -->
                    <ion-icon *ngIf="!isLoading && currentLanguage !== lang.code" name="chevron-forward-outline"
                        class="hover-icon"></ion-icon>
                </div>
            </div>
        </div>

        <!-- Drawer Footer -->
        <div class="drawer-footer">
            <div class="footer-text">
                <ion-icon name="globe-outline" class="globe-icon"></ion-icon>
                <span>{{ supportedLanguages.length }} {{ 'LANGUAGES_AVAILABLE' | translate }}</span>
            </div>
        </div>
    </div>

    <!-- Backdrop/Overlay -->
    <div class="backdrop" [class.visible]="isOpen" (click)="toggleDrawer()"></div>
</div>